import classNames from 'classnames';
import React from 'react';

interface LoaderProps {
  className?: string;
}

function Loader({ className }: LoaderProps) {
  return (
    <div className={classNames(className, 'w-full flex justify-center my-[40px]')}>
      <div className="loader" />
    </div>
  );
}

export default Loader;
